export default "__VITE_ASSET__CZAuXm8X__"